import { memo, useEffect } from 'react'

import {
  getAuthLogoutRoute,
  useLocationToVisitStorage,
} from '@surglogs-app/routing'

import { isExternalUserToken } from '../../helpers'
import { useAuthToken } from '../../hooks'

interface UnauthorizedErrorScreenProps {
  setLocationToVisit?: boolean
}

export const UnauthorizedErrorScreen = memo(
  ({ setLocationToVisit = false }: UnauthorizedErrorScreenProps) => {
    const { setValue } = useLocationToVisitStorage()
    const { token } = useAuthToken()

    useEffect(() => {
      if (setLocationToVisit) {
        setValue(window.location)
      }
    })

    useEffect(() => {
      window.location.href = getAuthLogoutRoute(
        isExternalUserToken(token)
          ? 'external_user_unauthorized'
          : 'inactivity',
      )
    })

    return null
  },
)
